// extracted by mini-css-extract-plugin
module.exports = {"new-table":"ClinicalTrials_new-table__1eIqU"};